// SP, TABLET時に表示される画面下のナビゲーションエリア
export const GLOBAL_NAVI_FOOTER_HEIGHT = 45;

export const GLOBAL_NAVI_HEIGHT = {
  PC: 49,
  SP: 45,
} as const;

export const VOD_LIST_HEADER_HEIGHT = {
  PC: 40,
  SP: 32,
} as const;

// /vod/list/ の絞り込みタグ表示エリアの高さ
export const VOD_LIST_TAG_LIST_HEIGHT = {
  PC: 40,
  SP: 32,
} as const;

export const LEFT_NAVI_WIDTH = 160;

/**  マイアイテムの仮想スクロールのpadding */
export const MY_INFINITY_SCROLL_AREA_PADDING = 16;

export const LIST_EMPTY_MESSAGE_HEIGHT = {
  PC: 144,
  TABLET: 198,
} as const;

/** 作品一覧(/vod/list/) 左ナビ上部のマージン */
export const LEFT_NAV_MARGIN_TOP = 32;
